import { InMemoryCache } from '@apollo/client/cache';
import introspectionQueryResultData from './instrospectionQueryResultData.json';

const cacheFactory = () => new InMemoryCache({
  possibleTypes: introspectionQueryResultData,
  typePolicies: {
    PrdAttribute: { keyFields: ['id', 'value', ['id']] },
    CrtLineItemAttr: { keyFields: ['id', 'value', ['id']] },
    OhLineItemAttr: { keyFields: ['id', 'value', ['id']] }
  }
});

export default cacheFactory;